import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { useAuth, useProgram, useConfig } from 'hooks';
import { trackViewMyRequests } from '~/sdk';
import useDishsItems from '~/hooks/useDishsItems';
import { config } from '~/utils/config';

function SearchForm() {
  const router = useRouter();
  const { logOut, participant, accessToken } = useAuth();
  const { program } = useProgram();
  const { data } = useConfig();
  const { getMyDishsItems, couldSeeResults } = useDishsItems();
  const canShowUploadInvoices =
    program.id === 2
      ? Boolean(participant?.group?.canUploadSnaps)
      : Boolean(data?.permissions?.canUploadSnaps);

  useEffect(() => {
    document.querySelector('body').addEventListener('click', onBodyClick);

    return () => {
      document.querySelector('body').removeEventListener('click', onBodyClick);
    };
  }, []);

  useEffect(() => {
    document.querySelector('.header-search.show-results') &&
      document.querySelector('.header-search.show-results').classList.remove('show-results');
    getMyDishsItems();
  }, [router.pathname]);

  const DASHBOARD_URL = process.env.NEXT_PUBLIC_DASHBOARD_URL || 'http://localhost:3002';

  const handleGoDashboard = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const token = localStorage.getItem('accessTokenLala4Store');
      const url = new URL(DASHBOARD_URL);
      if (token) url.searchParams.set('token', token);
      window.location.assign(url.toString());
    } catch {
      window.location.assign(DASHBOARD_URL);
    }
  };

  function onMenuClick(e) {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.parentNode.classList.toggle('show');
  }

  function onBodyClick(e) {
    if (e.target.closest('.header-search'))
      return (
        e.target.closest('.header-search').classList.contains('show-results') ||
        e.target.closest('.header-search').classList.add('show-results')
      );

    document.querySelector('.header-search.show') &&
      document.querySelector('.header-search.show').classList.remove('show');
    document.querySelector('.header-search.show-results') &&
      document.querySelector('.header-search.show-results').classList.remove('show-results');
  }

  const isAccountActive = router.pathname.startsWith('/pages/account');

  return (
    <div className="header-search hs-toggle dir-up">
      <a
        href="#"
        className={`search-toggle sticky-link ${isAccountActive ? 'active' : ''}`}
        role="button"
        onClick={onMenuClick}
      >
        <i className="d-icon-user"></i>
        <span>Cuenta</span>
      </a>

      <div
        className="input-wrapper"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
        onClick={(e: any) => {
          e.currentTarget.parentNode.classList.toggle('show');
        }}
      >
        {program.id === 33 &&
          participant.position.id.toString() === config.program.supervisorPositionId && (
            <Link
              href="/pages/create-participant"
              className="mb-2"
              onClick={() => trackViewMyRequests()}
            >
              <i className="d-icon-user mr-1"></i>
              Registrar Dependiente
            </Link>
          )}
        {program.id === 56 && (
          <Link href="#" className="mb-2" onClick={handleGoDashboard}>
            <i className="d-icon-direction mr-1"></i>
            Dashboard
          </Link>
        )}
        <Link href="/pages/account" className="mb-2" onClick={() => trackViewMyRequests()}>
          <i className="d-icon-user mr-1"></i>
          Mi Cuenta
        </Link>
        <Link
          href="/pages/account/?tab=requests"
          className="mb-2"
          onClick={() => trackViewMyRequests()}
        >
          <i className="d-icon-truck mr-1"></i>
          Mis Solicitudes
        </Link>

        <Link href="/pages/account/?tab=account-statement" className="mb-2">
          <i className="d-icon-money mr-1"></i>
          Estado de Cuenta
        </Link>

        {program.hasAcademy && (
          <Link href={`${program.academyUrl}?token=${accessToken}`} className="mb-2">
            <i className="d-icon-graduation-cap mr-1"></i>
            Capacitaciones
          </Link>
        )}

        {
          //todo: change this to filter by ingredient code and validate groups can upload invoices
          canShowUploadInvoices && (
            <Link href="/pages/upload-invoices">
              <i className="d-icon-camera1 mr-1 mb-1"></i>
              Subir Facturas
            </Link>
          )
        }

        {participant.isAConsumerRegistrar && (
          <Link href="/pages/create-pdv">
            <i className="d-icon-map mr-1"></i>
            Crear Punto de Venta
          </Link>
        )}

        {couldSeeResults && (
          <Link href="/pages/my-results">
            <i className="d-icon-cash mr-1 mb-1"></i>
            Mis Resultados
          </Link>
        )}
        {/* <Link href="/pages/change-my-password" className="mb-2">
          <i className="d-icon-lock mr-1"></i>
          Cambiar Mi Contraseña
        </Link> */}

        <Link href="/pages/my-requests" onClick={logOut}>
          <i className="d-icon-cancel mr-1"></i>
          Salir
        </Link>
      </div>
    </div>
  );
}

export default SearchForm;
